// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
  border-top: 3px solid var(--primary-background);
  border-right: 3px solid var(--primary-background);
  border-radius: 50%;
  animation: spin .7s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/loading-spinner/loading-spinner.component.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,iDAAiD;EACjD,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".spinner {\n  border-top: 3px solid var(--primary-background);\n  border-right: 3px solid var(--primary-background);\n  border-radius: 50%;\n  animation: spin .7s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
